import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HeaderSerasaComponent } from './header-serasa.component';
import { HeaderSerasaService } from './header-serasa.service';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
    declarations: [HeaderSerasaComponent],
    exports: [HeaderSerasaComponent],
    imports: [CommonModule, RouterModule, HttpClientModule],
    providers: [HeaderSerasaService]
})
export class HeaderSerasaModule {}
